import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';
import { Starfield } from '../entities/Starfield.js';


export class SceneManager {
    constructor(app) {
        this.app = app;
        this.scene = new THREE.Scene();
        this.container = document.getElementById('scene-container');
        
        this.createCamera();
        this.createRenderer();
        this.createLights();
    }

    createCamera() {
        this.camera = new THREE.PerspectiveCamera(
            75, // FOV
            window.innerWidth / window.innerHeight, // Aspect ratio
            0.1, // Near plane
            1000 // Far plane
        );
        this.camera.position.z = 5;
    }

    createRenderer() {
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.renderer.setClearColor(0x000000, 0); // Transparent background
        
        // Add renderer to DOM
        this.container.appendChild(this.renderer.domElement);
    }

    createLights() {
        // Ambient light for general illumination
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);

        // Directional light for shadows and depth
        const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
        directionalLight.position.set(5, 5, 5);
        this.scene.add(directionalLight);

        // Point light near camera for pod highlighting
        const pointLight = new THREE.PointLight(0x4a90e2, 1, 100);
        pointLight.position.set(0, 0, 5);
        this.scene.add(pointLight);
    }

    init() {
        // Additional initialization if needed
        this.createStarfield();
    }

    createStarfield() {
        this.starfield = new Starfield();
        this.scene.add(this.starfield);
    }

    onWindowResize() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(width, height);
    }

    render() {
        // Update TWEEN
        TWEEN.update();

        const currentMovement = this.app?.podManager?.getCurrentMovement();

        // Update starfield
        if (this.starfield) {
            this.starfield.update(currentMovement);
        }

        // Ensure camera is looking at origin
        this.camera.lookAt(0, 0, 0);
        
        // Render the scene
        this.renderer.render(this.scene, this.camera);
    }

    // Helper methods for other managers
    getScene() {
        return this.scene;
    }

    getCamera() {
        return this.camera;
    }
}
